import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-battery-empty",
  "use": "icon-s-battery-empty-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-battery-empty\"><path d=\"M2 8v7h16.995v-2H20v-3h-1.005V8zm18.9.2h.275c.456 0 .825.37.825.825v4.95a.825.825 0 0 1-.825.825H20.9v.55A1.65 1.65 0 0 1 19.25 17H1.65A1.65 1.65 0 0 1 0 15.35v-7.7C0 6.739.738 6 1.65 6h17.6c.911 0 1.65.739 1.65 1.65z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol